import { formatDateLocal } from "../../helpers/timeline";
export const columnsDataDevelopment = [
  {
    Header: "No",
    accessor: "__index", // virtual accessor
  },
  {
    Header: "Nomor Tiket",
    accessor: "number_ticket",
  },
  {
    Header: "Judul",
    accessor: "subject",
  },
  
  {
    Header: "Deskripsi",
    accessor: "description",
  },
  {
    Header: "Tiket dibuat",
    accessor: "created_at",
    Cell: (value) => formatDateLocal(value),
  },
  {
    Header: "Tiket diperbarui",
    accessor: "updated_at",
    Cell: (value) => formatDateLocal(value),
  },
];
